module.exports = __webpack_public_path__ + "img/202209281014505960ke.bd12cdae.png";